import { AbstractObjectRegistry } from "@mcleod/core";
import { DemoDefinition } from "./DemoDefinition";

export class DemoRegistry extends AbstractObjectRegistry<DemoDefinition> {
    private static registry: DemoRegistry;

    public static get(): DemoRegistry {
        this.initialize();
        return this.registry;
    }

    private static initialize() {
        if (this.registry == null)
            this.registry = new DemoRegistry();
    }
}
